<mat-list>
  <mat-list-item>
    <mat-icon matListItemIcon>access_time</mat-icon>
    <span matListItemTitle>Time</span>
    <span matListItemLine>{{ measurement().measured | date:'yyyy-MM-dd HH:mm:ss':'UTC' }} UTC</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>navigation</mat-icon>
    <span matListItemTitle>Wind directions</span>
    <span matListItemLine><b class="npdc-primary">True</b>: {{ measurement().windDirectionTrue | number }}°</span>
    <span matListItemLine><b class="npdc-error">Magnetic</b>: {{ measurement().windDirectionMagnetic | number }}°</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>air</mat-icon>
    <span matListItemTitle>Wind (gust)</span>
    <span matListItemLine>{{ measurement().windSpeedMs | number: '1.0-1' }} ({{ measurement().windGustMs | number: '1.0-1' }}) m/s</span>
    <span matListItemLine>{{ measurement().windSpeedKnots | number: '1.0-1' }} ({{ measurement().windGustKnots | number: '1.0-1' }}) knots</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>thermometer</mat-icon>
    <span matListItemTitle>Air temperature</span>
    <span matListItemLine>{{ measurement().airTemperature | number }}°C</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>humidity_percentage</mat-icon>
    <span matListItemTitle>Humidity</span>
    <span matListItemLine>{{ measurement().airHumidity | number }}%</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>dew_point</mat-icon>
    <span matListItemTitle>Dew point</span>
    <span matListItemLine>{{ measurement().dewPoint | number: '1.0-1' }}%</span>
  </mat-list-item>
  <mat-list-item>
    <mat-icon matListItemIcon>compress</mat-icon>
    <span matListItemTitle>Air pressure</span>
    <span matListItemLine>{{ measurement().pressure | number: '1.0-1' }} hPa</span>
  </mat-list-item>
</mat-list>
